import React, { useContext, useState, useEffect } from 'react';
import './App.css';
import PingNationWebfitTile from './components/PingNationWebfitTile/PingNationWebfitTile';
import { FittingRecommendationsProvider } from './context/fittingRecommendationsContext';
import { LocalizationContext } from './context/localizationContext';

function App(props) {
  const { organization } = props;
  const [isTileView, setTileView] = useState(true);
  const localization = useContext(LocalizationContext);
  const { localizationDispatch } = localization;

  useEffect(() => {
    localStorage.setItem('Organization', organization);
    if (organization !== 'US') {
      localizationDispatch({
        type: 'SET_LOCALIZATION',
        localization: organization,
      });
    }
  }, []);

  return (
    <div className="App">
      <FittingRecommendationsProvider>
        <PingNationWebfitTile />
      </FittingRecommendationsProvider>
    </div>
  );
}

export default App;
